import React from "react";
import { TableAUM, ProfileBulletPoints } from "@hedgefund/shared";
import { Carousel, Col, Empty, Row, Spin } from "antd";
import moment from "moment";

const AllocatorHomeTab = ({ fundProfileDetails, getCurrentCompanyPostFeed }) => {
  const { allocatorStratgy, getCompanyPostFeed, loading, perPage } = fundProfileDetails;

  // const liquidStrategy = allocatorStratgy
  //   ?.map((s) => s.strategies)
  //   ?.map((n) => n.name);
  const onLoadMore = () => {
    getCurrentCompanyPostFeed(1, perPage + perPage);
  }
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="nav-home"
        role="tabpanel"
        aria-labelledby="nav-home-tab"
      >
        <Row>
          <Col span={10}>
            <div className="rounded-large bg-white border p-xxl-4 p-3 mt-xxl-5 mt-4">
              <h5 data-bs-toggle="tooltip" data-bs-placement="top">
                AUM - Assets Under Management
              </h5>
              <div className="table-responsive hf-table-2 mt-xl-4 mt-3">
                <TableAUM />
              </div>
            </div>
            <div className="profile-extra-information mt-4">
              <ProfileBulletPoints
                title="Investor Category"
                description={
                  allocatorStratgy?.investorTypeName
                    ? allocatorStratgy?.investorTypeName
                    : "No activity found!"
                }
              />

              <ProfileBulletPoints
                title="Investor Decision Process"
                description={
                  allocatorStratgy?.idpi
                    ? allocatorStratgy?.idpi
                    : "No activity found!"
                }
              />

              <ProfileBulletPoints
                title="Net Dollar Exposure"
                description={
                  allocatorStratgy?.netDollar === 0
                    ? "No activity found!"
                    : allocatorStratgy?.netDollar
                      ? allocatorStratgy?.netDollar
                      : "No activity found!"
                }
              />
              <ProfileBulletPoints
                title="Liquid Strategy Interests"
                editButton={false}
                listData={allocatorStratgy}
              />

              <ProfileBulletPoints
                title="Firm Size Interest"
                description="No activity found!"
              />
            </div>
          </Col>
          <Col span={13} offset={1} >
            {getCompanyPostFeed?.items?.length > 0 ?
              getCompanyPostFeed?.items?.map((post) => {
                return (
                  <Row className="bg-white rounded-large p-xxl-4 p-3 mt-xxl-5 mt-3">
                    <Col span={2}>
                      <img src={post?.userProfileImage ? post?.userProfileImage : "/assets/images/bg1.png"} style={{ height: "70px", borderRadius: "10px" }} alt="Big Image" />
                    </Col>
                    <Col span={21} className="ml-3">
                      <Col span={24}>
                        <p style={{ margin: "0px", fontSize: "20px" }}><b>{post?.userFullName}</b></p>
                      </Col>
                      <Col span={24}>
                        <label> {post?.tenantName}</label>
                      </Col>
                      <Col span={24}>
                        <label>{post?.userTitle}</label>
                      </Col>
                    </Col>
                    <Col span={24} className="ml-3 mt-3">
                      <p>{post?.description}</p>
                    </Col>
                    {post?.records?.length > 0 && (
                      post?.records?.map((record) => {
                        return (
                          <Carousel autoplay>
                            <Col span={24}>
                              <img src={record.url} style={{ height: "400px", width: "100%", borderRadius: "10px" }} alt="Big Image" />
                            </Col>
                          </Carousel>
                        )
                      })
                    )}
                    <Col span={24}>
                      <p style={{ float: "right" }}><b>Posted Date : {moment(post?.creationTime).format("D MMM, YYYY")}</b></p>
                    </Col>
                  </Row>
                )
              }) : (
                <Row className="rounded-large p-xxl-4 p-3 mt-xxl-5 mt-3">
                  <Col span={24}>
                    <Empty />
                  </Col>
                </Row>
              )
            }
            {(() => {
              if (getCompanyPostFeed?.items?.length > getCompanyPostFeed.rows) {
                return (
                  <Row style={{ width: "100%", display: "flex", textAlign: "center" }}>
                    <Col span={24}>
                      <button className="btn btn-primary mr-4 mt-3"
                        onClick={onLoadMore}>{loading ? <Spin /> : "Load More"} </button>
                    </Col>
                  </Row>
                )
              }
            })()}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AllocatorHomeTab;
